import { render, staticRenderFns } from "./menuGroupItem.vue?vue&type=template&id=8575abb2&scoped=true"
import script from "./menuGroupItem.vue?vue&type=script&lang=js"
export * from "./menuGroupItem.vue?vue&type=script&lang=js"
import style0 from "./menuGroupItem.vue?vue&type=style&index=0&id=8575abb2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8575abb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8575abb2')) {
      api.createRecord('8575abb2', component.options)
    } else {
      api.reload('8575abb2', component.options)
    }
    module.hot.accept("./menuGroupItem.vue?vue&type=template&id=8575abb2&scoped=true", function () {
      api.rerender('8575abb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/sidebar/components/menuGroupItem.vue"
export default component.exports